// Festive & standing offers shown in the rotating top banner.
// To change an offer, edit the text here (or send the new wording to us on WhatsApp and we'll update it).
export const OFFERS = [
  {
    id: "festive-garments",
    tag: "Festive Offer",
    text: "Flat 30% off on garments — on every festival",
  },
  {
    id: "festive-footwear",
    tag: "Festive Offer",
    text: "Flat 10% off on all footwear — on every festival",
  },
  {
    id: "festivals",
    tag: "Diwali · Ugadi & more",
    text: "Celebrate every festival with 30% off garments & 10% off footwear",
  },
  {
    id: "delivery",
    tag: "Always On",
    text: "Free home delivery within 5 km on orders above ₹1,500",
  },
];
